import { atom } from "jotai";

export const sessionIdAtom = atom("");
